var _effectorFileName = "/src/page-content/group-lessons/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { Main } from '@/page-content/group-lessons/components/main';
import { PlusesGroupLessons } from '@/page-content/group-lessons/components/pluses-group-lessons';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { SliderCards } from '@/widgets/layouts/main/slider-cards';
import { CardKey } from '@/widgets/layouts/main/slider-cards/slider-card/types';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { CARDS } from './constants/cards';
export const GroupLessonsPage = () => {
  const router = useRouter();
  const quizResult = router.query.quizResult as CardKey | undefined;
  return <>
      <PageSeo title="Групповые занятия" description={`Групповые занятия - отличный вариант выучить деловой английский в группе единомышленников и завести полезные знакомства. ${APP_TITLE} – деловой английский для работы.`} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - Групповые занятия`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description={`Групповые занятия - отличный вариант выучить деловой английский в группе единомышленников и завести полезные знакомства. ${APP_TITLE} – деловой английский для работы.`} about={['английский', 'онлайн', 'групповые занятия']} />

      <Main />

      <PlusesGroupLessons />

      <SliderCards cards={CARDS} quizResult={quizResult} />

      <Reviews />

      <CallToAction withForm />
    </>;
};
GroupLessonsPage.Layout = MainLayout;